export default __webpack_public_path__ + "static/media/abelEmmanuel.529c7dcb.jpg";